import logo from '../../assets/arrive-symbol-white-RGB.svg';

const ArriveLogoIcon = () => (
    <img src={logo} alt="Arrive" style={{ height: 40, width: 'auto' }} />
);
export default ArriveLogoIcon;